import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { useEffect } from 'react';
import useAuthStore from '@/features/auth/stores/authStore';
import { DomainUser } from '@/features/auth/dto/user/User';
import { Logger } from '@/utils/loggingService';
import { useLocation } from 'react-router-dom';

export default function useLogging() {
  const user = useAuthStore((state) => state.domainUser);

  useEffect(() => {
    if (user) {
      Logger.setupLoggerContext(user.id, user.email);
      setupLogRocket(user);
    }
  }, [user]);

  const location = useLocation();
  useEffect(() => {
    Logger.logRouteChange(`${location.pathname}${location.search}`);
  }, [location]);
}

function setupLogRocket(user: DomainUser) {
  let appName: string;
  let rootHostname: string;

  switch (process.env.REACT_APP_ENV) {
    case 'prod': {
      appName = 'inu0wd/oncolens-production';
      rootHostname = 'oncolens.com';
      break;
    }
    case 'uat': {
      appName = 'qjkcch/oncolens';
      rootHostname = 'oncolens.dev';
      break;
    }
    case 'staging': {
      appName = 'qjkcch/oncolens';
      rootHostname = 'staging.oncolens.com';
      break;
    }
    default: {
      // set these to test logrocket locally
      appName = '';
      rootHostname = '';
      break;
    }
  }

  if (appName.length > 0) {
    LogRocket.init(appName, {
      mergeIframes: true,
      rootHostname: rootHostname,
      dom: {
        inputSanitizer: true,
        textSanitizer: true,
      },
      network: {
        requestSanitizer: function (request) {
          request.body = null!;
          return request;
        },
      },
    });

    LogRocket.identify(user.id.toString(), {
      email: user.email,
      env: process.env.NODE_ENV,
      userId: user.id,
    });

    setupLogRocketReact(LogRocket);
  }
}
